import { render, staticRenderFns } from "./basic_button.vue?vue&type=template&id=6e736d3a&"
import script from "./basic_button.vue?vue&type=script&lang=js&"
export * from "./basic_button.vue?vue&type=script&lang=js&"
import style0 from "./basic_button.vue?vue&type=style&index=0&id=6e736d3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports